import { Box, Checkbox, Text } from '@chakra-ui/react';
import { FieldValues, Path, useFormContext } from 'react-hook-form';

interface MarketingCheckboxProps<T extends FieldValues> {
  name: Path<T>;
}

export const MarketingCheckbox = <T extends {}>({
  name,
}: MarketingCheckboxProps<T>) => {
  const { register } = useFormContext<T>();
  return (
    <Box pt={22}>
      <Checkbox
        textAlign="left"
        data-testid="marketing-checkmark"
        fontWeight={400}
        p={0}
        {...register(name)}
      >
        <Text ml={1}>
          I would like tips on how to use Session Studio, information on
          features, news and more.
        </Text>
      </Checkbox>
    </Box>
  );
};
